import { generateState } from '../builder'

export default {
  adaptationBudgets: [],
  ...generateState('getAdaptationBudgets'),
}
